import { actions } from './actions'

const initialStates = {
  bibliotecasPrecios: {
    data: [],
    loading: false,
    error: '',
  },
  bibliotecasPreciosExcelFile: {
    data: [],
    loading: false,
    error: '',
  },
  productosBibPreciosProducto: {
    data: [],
    loading: false,
    error: '',
    reload: false,
  },
}

export default function bibPrecioReducer(state = initialStates, action) {
  switch (action.type) {
    case actions.BIBPRECIOS_GET_URL_EXCEL_FILE_REQUESTED:
      return {
        ...state,
        bibliotecasPreciosExcelFile: { ...state.bibliotecasPreciosExcelFile, loading: true },
      }
    case actions.BIBPRECIOS_GET_URL_EXCEL_FILE_SUCCEEDED:
      return {
        ...state,
        bibliotecasPreciosExcelFile: {
          ...state.bibliotecasPreciosExcelFile,
          data: action.payload,
          loading: false,
        },
      }
    case actions.BIBPRECIOS_GET_URL_EXCEL_FILE_FAILED:
      return {
        ...state,
        bibliotecasPreciosExcelFile: {
          ...state.bibliotecasPreciosExcelFile,
          loading: false,
          error: action.error,
        },
      }

    case actions.BIBPRECIOS_FILTERED_LOAD_REQUESTED:
      return { ...state, bibliotecasPrecios: { ...state.bibliotecasPrecios, loading: true } }
    case actions.BIBPRECIOS_FILTERED_LOAD_SUCCEEDED:
      return {
        ...state,
        bibliotecasPrecios: { ...state.bibliotecasPrecios, data: action.payload, loading: false },
      }
    case actions.BIBPRECIOS_FILTERED_LOAD_FAILED:
      return {
        ...state,
        bibliotecasPrecios: { ...state.bibliotecasPrecios, loading: false, error: action.error },
      }

    case actions.BIBPRECIOS_FILTERED_BY_ID_REQUESTED:
      return {
        ...state,
        bibliotecasPrecios: { ...state.bibliotecasPrecios, loading: true, error: '' },
      }
    case actions.BIBPRECIOS_FILTERED_BY_ID_SUCCEEDED:
      return {
        ...state,
        bibliotecasPrecios: { data: action.payload, loading: false, error: '' },
      }
    case actions.BIBPRECIOS_FILTERED_BY_ID_FAILED:
      return {
        ...state,
        bibliotecasPrecios: { ...state.bibliotecasPrecios, loading: false, error: action.error },
      }

    case actions.BIBPRECIOS_DELETED_REQUESTED:
      return {
        ...state,
        bibliotecasPrecios: { ...state.bibliotecasPrecios, loading: true, error: '' },
      }
    case actions.BIBPRECIOS_DELETED_SUCCEEDED:
      return {
        ...state,
        bibliotecasPrecios: {
          ...state.bibliotecasPrecios,
          data: state.bibliotecasPrecios.data.filter(f => f.id !== action.id),
          loading: false,
          error: '',
        },
      }
    case actions.BIBPRECIOS_DELETED_FAILED:
      return {
        ...state,
        bibliotecasPrecios: { ...state.bibliotecasPrecios, loading: false, error: action.error },
      }

    case actions.BIBPRECIOS_INSERTED_REQUESTED:
      return {
        ...state,
        bibliotecasPrecios: { ...state.bibliotecasPrecios, loading: true, error: '' },
      }
    case actions.BIBPRECIOS_INSERTED_SUCCEEDED:
      return {
        ...state,
        bibliotecasPrecios: {
          data: [...state.bibliotecasPrecios.data, action.payload],
          loading: false,
          error: '',
        },
      }
    case actions.BIBPRECIOS_INSERTED_FAILED:
      return {
        ...state,
        bibliotecasPrecios: { ...state.bibliotecasPrecios, loading: false, error: action.error },
      }

    case actions.BIBPRECIOS_UPDATED_REQUESTED:
      return {
        ...state,
        bibliotecasPrecios: { ...state.bibliotecasPrecios, loading: true, error: '' },
      }
    case actions.BIBPRECIOS_UPDATED_SUCCEEDED:
      return {
        ...state,
        bibliotecasPrecios: {
          ...state.bibliotecasPrecios,
          data: action.payload,
          loading: false,
          error: '',
        },
      }
    case actions.BIBPRECIOS_UPDATED_FAILED:
      return {
        ...state,
        bibliotecasPrecios: { ...state.bibliotecasPrecios, loading: false, error: action.error },
      }

    case actions.BIBPRECIOS_PRODUCTOS_FILTERED_REQUESTED:
      return {
        ...state,
        productosBibPreciosProducto: { ...state.productosBibPreciosProducto, loading: true },
      }
    case actions.BIBPRECIOS_PRODUCTOS_FILTERED_SUCCEEDED:
      return {
        ...state,
        productosBibPreciosProducto: {
          ...state.productosBibPreciosProducto,
          data: action.payload,
          loading: false,
        },
      }
    case actions.BIBPRECIOS_PRODUCTOS_FILTERED_FAILED:
      return {
        ...state,
        productosBibPreciosProducto: {
          ...state.productosBibPreciosProducto,
          loading: false,
          error: action.error,
        },
      }

    case actions.BIBPRECIOS_PRODUCTOS_DELETED_REQUESTED:
      return {
        ...state,
        productosBibPreciosProducto: {
          ...state.productosBibPreciosProducto,
          loading: true,
          error: '',
        },
      }
    case actions.BIBPRECIOS_PRODUCTOS_DELETED_SUCCEEDED: {
      const ids = action.payload?.map(e => e.id)
      return {
        ...state,
        productosBibPreciosProducto: {
          ...state.productosBibPreciosProducto,
          data: state.productosBibPreciosProducto.data.filter(
            producto => !ids.includes(producto.id),
          ),
          loading: false,
          error: '',
          reload: true,
        },
      }
    }
    case actions.BIBPRECIOS_PRODUCTOS_DELETED_FAILED:
      return {
        ...state,
        productosBibPreciosProducto: {
          ...state.productosBibPreciosProducto,
          loading: false,
          error: action.error,
        },
      }

    case actions.BIBPRECIOS_PRODUCTOS_UPDATED_REQUESTED:
      return {
        ...state,
        productosBibPreciosProducto: {
          ...state.productosBibPreciosProducto,
          loading: true,
          error: '',
        },
      }
    case actions.BIBPRECIOS_PRODUCTOS_UPDATED_SUCCEEDED:
      return {
        ...state,
        productosBibPreciosProducto: {
          ...state.productosBibPreciosProducto,
          data: state.productosBibPreciosProducto.data,
          loading: false,
          error: '',
          reload: true,
        },
      }
    case actions.BIBPRECIOS_PRODUCTOS_UPDATED_FAILED:
      return {
        ...state,
        productosBibPreciosProducto: {
          ...state.productosBibPreciosProducto,
          loading: false,
          error: action.error,
        },
      }

    default:
      return state
  }
}
